module.exports = " <div> Nav Bar </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 390
// module chunks = 0